import React from 'react';

import { ChangeHandler } from 'src/presentation/components/pages/integrations/types';
import CompactSection from 'src/presentation/components/pages/integrations/editorComponents/CompactSection';
import { Row } from 'src/presentation/components/forms/Layout';
import {
  WrappedField,
  MaskedField,
} from 'src/presentation/components/pages/integrations/editorComponents/EditorFields';

function renderLoopReturnsConfigurations(
  onChange: (attr: string) => ChangeHandler,
  maskedFields: string[]
): JSX.Element {
  return (
    <>
      <CompactSection
        description={`Loop Returns is a Shopify platform that enables merchants to simplify the returns process and encourage customers to turn returns into exchanges by offering 4 ways to return: exchange, shop now, store credit or refund.`}
      >
        <Row>
          <WrappedField
            attr="name"
            label="Name"
            placeholder="App Name"
            description="This is the name that will be displayed throughout Gladly"
            data-aid="loop-returns-integration-name"
            autoFocus={true}
            onChange={onChange('name')}
          />
        </Row>
        <Row>
          <MaskedField
            attr="secrets.apiToken"
            label="API Token"
            description="This is the API token used to fetch data from Loop Returns."
            showClearButton={maskedFields.includes('apiToken')}
            isMasked={maskedFields.includes('apiToken')}
            data-aid="loop-returns-token"
            onChange={onChange('secrets.apiToken')}
          />
        </Row>
      </CompactSection>
    </>
  );
}

export default renderLoopReturnsConfigurations;
